import { useDidMount } from '@hooks';
import { api, appConfig } from '@services';
import { useState } from 'react';
import { useUniversal_account } from '../useReducer';

export const useCheckToken = () => {
	const { dispatch, actions } = useUniversal_account();

	const [isCheck, setCheck] = useState(false);
	//
	const token = () => localStorage.getItem('token');
	const tokenExpireTime = () => localStorage.getItem('token-expired-time');
	const invalidToken = () => !token() || !tokenExpireTime() || Date.now() >= Number(tokenExpireTime());

	const checkToken = async () => {
		if (invalidToken()) {
			dispatch(actions.logout());
			appConfig.isDevelopment && console.log('invalid token');
		}
		await api.$auth_init(
			{
				// onFail: () => sleep(5000).then(() => api.$auth_init({ showFailMessage: false }, {})),
				showFailMessage: false,
			},
			{},
		);
		setCheck(true);
	};

	useDidMount(() => {
		checkToken();
	}, []);

	return { isCheck };
};

// function sleep(ms) {
// 	return new Promise((res, rej) => setTimeout(res, ms));
// }
